module.exports = __webpack_public_path__ + "static/media/Icon-Email.1f2f6f9c.svg";